export default "/images/bd77e52c47af32111d5fcaa28d30a465.png";